export default __webpack_public_path__ + "static/media/CMS_Teams.3cc190dd.svg";